import {
  Laptop,
  Server,
  HardDrive,
  Monitor,
  Barcode,
  ShieldCheck,
  Power,
  Database,
  Router,
  Dock,
  Printer,
  Briefcase,
  Cpu,
  MemoryStick,
  Headset,
  Phone,
  Camera,
  BatteryCharging,
  Mouse,
} from 'lucide-react';
import type { ComponentType } from 'react';

export const categories = [
  'All Products',
  'Corporate Computing',
  'Data Center Products',
  'Components',
  'Corporate Electronics',
  'Barcoding',
] as const;

export type Category = (typeof categories)[number];

export type Product = {
  id: number;
  title: string;
  category: Category;
  icon: ComponentType<{ className?: string }>;
  cssClass: string;
};

export const products: Product[] = [
  // Group A: Data Center Products
  { id: 1, title: 'Firewalls', category: 'Data Center Products', icon: ShieldCheck, cssClass: 'datacenter' },
  { id: 2, title: 'Power', category: 'Data Center Products', icon: Power, cssClass: 'datacenter' },
  { id: 3, title: 'Storage', category: 'Data Center Products', icon: Database, cssClass: 'datacenter' },
  { id: 4, title: 'Networking', category: 'Data Center Products', icon: Router, cssClass: 'datacenter' },
  { id: 5, title: 'Servers', category: 'Data Center Products', icon: Server, cssClass: 'datacenter' },

  // Group B: Corporate Computing
  { id: 6, title: 'Docking Stations', category: 'Corporate Computing', icon: Dock, cssClass: 'corporate' },
  { id: 7, title: 'Chromebooks', category: 'Corporate Computing', icon: Laptop, cssClass: 'corporate' },
  { id: 8, title: 'Laptops', category: 'Corporate Computing', icon: Laptop, cssClass: 'corporate' },
  { id: 9, title: 'Printers', category: 'Corporate Computing', icon: Printer, cssClass: 'corporate' },
  { id: 10, title: 'Desktops', category: 'Corporate Computing', icon: Monitor, cssClass: 'corporate' },
  { id: 11, title: 'Laptop Accessories', category: 'Corporate Computing', icon: Briefcase, cssClass: 'corporate' },

  // Group C: Components
  { id: 12, title: 'SSD', category: 'Components', icon: HardDrive, cssClass: 'components' },
  { id: 13, title: 'CPUs', category: 'Components', icon: Cpu, cssClass: 'components' },
  { id: 14, title: 'GPUs', category: 'Components', icon: Cpu, cssClass: 'components' },
  { id: 15, title: 'Hard Drives', category: 'Components', icon: HardDrive, cssClass: 'components' },
  { id: 16, title: 'DACs And SFPs', category: 'Components', icon: Router, cssClass: 'components' },
  { id: 17, title: 'Memory', category: 'Components', icon: MemoryStick, cssClass: 'components' },

  // Group D: Corporate Electronics
  { id: 18, title: 'Monitors', category: 'Corporate Electronics', icon: Monitor, cssClass: 'electronics' },
  { id: 19, title: 'Headsets', category: 'Corporate Electronics', icon: Headset, cssClass: 'electronics' },
  { id: 20, title: 'IP Phones', category: 'Corporate Electronics', icon: Phone, cssClass: 'electronics' },
  { id: 21, title: 'Webcams', category: 'Corporate Electronics', icon: Camera, cssClass: 'electronics' },
  { id: 22, title: 'UPS', category: 'Corporate Electronics', icon: BatteryCharging, cssClass: 'electronics' },
  { id: 23, title: 'Mouse', category: 'Corporate Electronics', icon: Mouse, cssClass: 'electronics' },
  { id: 24, title: 'Printers And Scanners', category: 'Corporate Electronics', icon: Printer, cssClass: 'electronics' },
  { id: 25, title: 'Thermal Printers', category: 'Corporate Electronics', icon: Printer, cssClass: 'electronics' },

  // Group E: Barcoding
  { id: 26, title: 'Barcode Printers', category: 'Barcoding', icon: Printer, cssClass: 'barcoding' },
  { id: 27, title: 'Barcode Scanners', category: 'Barcoding', icon: Barcode, cssClass: 'barcoding' },
];
